import { r, createSender, createRemover, createUpdater } from '@/plugins/resource/resource'
import { queryPostfix } from '@/plugins/resource/api'

const c = (...args) => args.join('')

// Models
const MODEL = 'company'

export const companyApi = {
  detail: r('/detail{/id}/', MODEL),
  update: r('/update{/id}/', MODEL, createUpdater),
  chainList: r(queryPostfix('/network-list{/chain_id}/', []), MODEL),
  facility: {
    create: r('{/facility}/create/', MODEL, createSender),
    detail: r('{/facility}/detail/', MODEL),
    list: r(queryPostfix('{/facility}/list/', []), MODEL),
    setCompany: r('{/facility}/set-company/', MODEL, createSender),
  },
}
